import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
  }

  render() {
    if (this.state.error) {
      return (
        <div data-testid="error-boundary" style={{ padding: 24, color: '#fff', background: '#111', fontFamily: 'monospace', fontSize: 13, whiteSpace: 'pre-wrap' }}>
          <h2 style={{ color: '#f87171' }}>Render error</h2>
          <div>{String(this.state.error && this.state.error.message)}</div>
          <div style={{ marginTop: 12, color: '#9ca3af' }}>{String(this.state.error && this.state.error.stack)}</div>
          <div style={{ marginTop: 12, color: '#60a5fa' }}>{this.state.info && this.state.info.componentStack}</div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
